import React, { useContext, useEffect, useMemo, useState } from 'react';

const TopBarState = React.createContext({
  title: null,
  subtitle: null,
  injectedTopBarItems: null,
});
const ChangeTopBarState = React.createContext(null);

/**
 * The API provider is a wrapper around the API that can display error
 * messages in a UI Snackbar if any occur. This allows all components
 * to use the API while getting a basic level of feedback on errors
 * without explicitly handling those errors
 *
 * @param children
 * @returns {Element}
 * @constructor
 */
export const TopBarStateProvider = ({ children }) => {
  const [topBarState, setTopBarState] = useState({
    title: null,
    subtitle: null,
    injectedTopBarItems: null,
    hidden: null,
  });

  const changeTopBarState = useMemo(() => {
    return {
      setTopBarTitle(title) {
        setTopBarState((prevState) => ({
          ...prevState,
          title: title,
        }));
      },
      setTopBarSubtitle(subtitle) {
        setTopBarState((prevState) => ({
          ...prevState,
          subtitle: subtitle,
        }));
      },
      setTopBarInjectedTopBarItems(injectedTopBarItems) {
        setTopBarState((prevState) => ({
          ...prevState,
          injectedTopBarItems: injectedTopBarItems,
        }));
      },
      setHidden(hidden) {
        setTopBarState((prevState) => ({
          ...prevState,
          hidden: hidden,
        }));
      },
    };
  }, []);

  return (
    <TopBarState.Provider value={topBarState}>
      <ChangeTopBarState.Provider value={changeTopBarState}>
        {children ?? null}
      </ChangeTopBarState.Provider>
    </TopBarState.Provider>
  );
};

export const TopBarConfiguration = ({
  title,
  subtitle,
  hidden = false,
  injectedTopBarItems,
  children,
}) => {
  // const topBarState = useContext(TopBarState);
  const changeTopBarStateObj = useContext(ChangeTopBarState);

  useEffect(() => {
    changeTopBarStateObj.setTopBarTitle(title);
    changeTopBarStateObj.setTopBarSubtitle(subtitle);
    changeTopBarStateObj.setTopBarInjectedTopBarItems(injectedTopBarItems);
    changeTopBarStateObj.setHidden(hidden);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, subtitle, injectedTopBarItems]);

  return <>{children}</>;
};

export const useTopBarState = useContext.bind(null, TopBarState);
export const useChangeTopBarState = useContext.bind(null, ChangeTopBarState);
